import { HttpClient } from '@angular/common/http';
import { ActivityLog } from '@app/shared/models/activity-log';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

export class ActivityLogApi {
  constructor(public readonly http: HttpClient) {}

  // mock data
  getAll(): Observable<ActivityLog[]> {
    return this.http.get<ActivityLog[]>('assets/mock/activity-log.json').pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
